// extracted by mini-css-extract-plugin
export default {"adminstudent":"AdminStudent_adminstudent__fdTtP","adminstudent__container":"AdminStudent_adminstudent__container__c7CBq"};